import React from "react";

const Success = () => {


  return (
    <div className="step-1-submit2 h-screen">
      {/*  form has been submitted successfully */}
      <div className="submit-content flex flex-col justify-center items-center">
        <svg
          viewBox="0 0 26 26"
          xmlns="http://www.w3.org/2000/svg"
          className="checkmark"
        >
          <g
            stroke="currentColor"
            stroke-width="2"
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              className="circle"
              d="M13 1C6.372583 1 1 6.372583 1 13s5.372583 12 12 12 12-5.372583 12-12S19.627417 1 13 1z"
            />
            <path className="tick" d="M6.5 13.5L10 17 l8.808621-8.308621" />
          </g>
        </svg>
        <h1 className="text-secondary-color font-nueu text-2xl mt-4 md:mt-2 md:text-3xl">
          Successful
        </h1>
        <p className="text-base md:text-xl text-slate-700">
          Your response has been submitted successfully, thank you.
        </p>
        <br />

      </div>
    </div>
  );
};



export default Success